import { FlexCol } from "ui-kit/Layout/Flex";
import { ListItem } from ".";
import classNames from "classnames";
import styles from "./List.module.css";
import TextFieldsV2 from "../TextFieldsV2";

const ItemText = ({
  text,
  noGutter,
  isVisible,
}: {
  text?: ListItem["text"];
  noGutter?: boolean;
  isVisible: boolean;
}) => (
  <FlexCol className={classNames(styles.text, isVisible && styles.open)}>
    <TextFieldsV2
      text={text}
      variantText="bodyRg"
      gutterGap={noGutter ? 0 : 2}
      gutterBottom={0}
    />
  </FlexCol>
);

export default ItemText;
